import React from "react";
import styled from "@emotion/styled";
import { regexPattern } from "utils/config";

const StyledInput = styled.input`
  padding: 6px;
  width: 90%;
  height: 29px;
  border: 1px solid #e2e4e7;
  border-radius: 3px;
  transition: border-color 0.3s, box-shadow 0.3s;
  outline: none;
  background-color: ${({ disabled }) => (disabled ? "#f5f5f5" : "#fff")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "text")};
  text-transform: ${({ uppercase, capitalize }) =>
    uppercase ? "uppercase" : capitalize ? "capitalize" : "none"};

  // Change border color and add box-shadow on hover
  &:hover {
    border-color: ${({ disabled }) => (disabled ? "#e2e4e7" : "#1976d2")};
  }

  // Change border color and add box-shadow on focus
  &:focus {
    border-color: ${({ disabled }) => (disabled ? "#e2e4e7" : "#1976d2")};
    box-shadow: 0 0 5px rgba(25, 118, 210, 0.8);
  }
`;

// Reusable FolderStructureInput component
const FolderStructureInput = ({
  name,
  value,
  type = "text",
  style,
  onChange,
  required = false,
  disabled = false,
  maxLength = 100,
  regexType,
  capitalize = false,
  uppercase = false,
}) => {
  // Handler to manage input changes with validation
  const handleChange = (e) => {
    let inputValue = e.target.value;
    let trimmedValue =
      typeof inputValue === "string" ? inputValue.trimStart() : inputValue;

    if (capitalize) {
      // Ensure the first letter is always capitalized
      trimmedValue =
        trimmedValue.charAt(0).toUpperCase() + trimmedValue.slice(1);
    }

    if (uppercase) {
      trimmedValue = trimmedValue.toUpperCase();
    }

    // Check regex pattern if provided and only allow valid characters
    if (regexType) {
      const regex = new RegExp(regexPattern[regexType]);
      if (!regex.test(trimmedValue)) return;
    }

    // Check length
    if (inputValue.length > maxLength) return;

    // Update the parent component with the trimmed value
    onChange(name, trimmedValue);
  };

  return (
    <StyledInput
      name={name}
      value={value || ""}
      type={type}
      style={style}
      onChange={handleChange}
      required={required}
      disabled={disabled}
      maxLength={maxLength}
      autoComplete="off"
      capitalize={capitalize}
    />
  );
};

export default FolderStructureInput;
